(ns ui.components.search-selector.components.searchbox
  (:require [oops.core :as oops]
            [common.localization :as loc]
            [common.util :as cu]
            [ui.dom-globals :as dg]
            [ui.util :as uu]))

(defn view
  [{:keys [dom-id placeholder left right
           class input-class value query
           autofocus?
           on-click on-blur on-change
           on-enter on-esc on-focus]}]
  [:div
   {:class (uu/cm
            "py-3 flex justify-between relative"
            "border border-solid border-base-light-border-paler"
            class)}
   (when left
     left)
   (when (and value
              (cu/empty-value? query))
     [:div
      {:class (uu/cm "absolute left-0 pl-4"
                     "border-none focus:outline-none focus:shadow-none")}
      (:label value)])
   [:input
    {:id dom-id
     :class (uu/cm "w-full pl-4 border-none focus:outline-none focus:shadow-none"
                   input-class)
     :tab-index   998
     :placeholder (when-not value
                    (or placeholder
                        (loc/tr :enter-search-query-to-see-results)))
     :auto-focus  (boolean autofocus?)
     :value query
     :on-focus (fn [e]
                 (let [target (dg/target e)]
                   (oops/oset! target "autocomplete" "off")
                   (when (fn? on-focus)
                     (on-focus))))
     :on-click (fn [e]
                 (dg/stop-propagation e)
                 (when (fn? on-click)
                   (on-click e)))
     :on-blur (fn [e]
                (when (fn? on-blur)
                  (on-blur (dg/event-target-value e))))
     :on-change (fn [e]
                  (when (fn? on-change)
                    (on-change (dg/event-target-value e))))
     :on-key-down (fn [e]
                    (when (and (= "Enter" (dg/event-key e))
                               (fn? on-enter))
                      (on-enter))
                    (when (and (= "Escape" (dg/event-key e))
                               (fn? on-esc))
                      (on-esc)))}]
   (when right
     right)])
